import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";


@Component({
    selector: 'app-attractions-list',
    templateUrl: './attractions-list.component.html'
})
export class AttractionsListComponent implements OnInit {

    public slug;
    banner_image = './assets/images/banners/art-entertainment-banner.jpg';
    banner_text = '<p>Owing to Hanoi and the North Vietnam’s incredibly rich and deep-rooted cultural history, beautiful landscapes, stunning beaches and national parks…there is plenty to explore and discover around the city and the region. Museums, galleries, fantastic architecture, ancient villages, temples and pagodas are all in abundance - not to mention the stunning outlying natural landscapes. From the towering peaks of mountain karsts and rice terraces to the quiet, cobbled roads of the UNESCO protected ancient villages, sightseeing in the region offers a wonderfully diverse mix of experiences. </p>' +
        '<p>Choose to pack in a full day of sightseeing in the city, or take things further afield on multi - day trip or overnight homestay in the outer areas. Whether by solo-exploration or curated tour, the sights and sounds of Hanoi are something you’ll never forget.</p>';
    banner_title = 'Things To Do';

    tour_image = './assets/images/banners/activitiy-tour-banner.jpg';
    tour_text = '<p>Hanoi and the North of Vietnam, spell-binding natural beauty, fascinating culture, mouth-watering food and warm, friendly people promise to bring you a travel experience you’ll never forget.</p>' +
        '<p>The cascading rice terraces and challenging treks in Sapa, the karst mountains and serene pagodas in Ninh Binh, the jewel colored waters and seemingly infinite islands in Halong Bay, and the fast-moving buzz of city life in Hanoi are only a few of the region’s main draws.</p>' +
        '<p>From the winding drives just made for road tripping, to the luxuriant jungles and national parks, North Vietnam is an ideal place for all kinds of tour activities, be it rock climbing, soloing, trekking, hiking, cycling, kayaking, camping, sailing, or snorkeling.</p>';
    tour_title = 'Tours & Activities';

    category = {
        id: '',
        title: '',
        content: '',
        cover_image: ''
    };
    thingsToDos = [];
    allThings = [];

    regions = [];
    regionsPart: Array<any>;
    allRegions: Array<any>;
    regionCollapsed: boolean;

    categories = [];
    allCategories: Array<any>;
    categoriesPart: Array<any>;
    categoriesCollapsed: boolean;
    categoryHasMore: boolean;

    facilityGroups = [];

    tour_categories = [];
    tourCategoriesPart: Array<any>;
    allTourCategories: Array<any>;
    tourCategoryCollapsed: boolean;
    tourHasMore: boolean;

    checked_categories = [];
    checked_tour_categories = [];
    selected_regions = '';
    selected_facilities = '';
    selected_categories = '';
    selected_tour_categories = '';

    max_price = 100000000;
    fee_start = 0;
    fee_end = 'end';

    type = '';
    tours = [];

    next = null;

    parent_categories = {
        "tours-and-activities": '',
        "attractions": '',
        "art-entertainment": '',
        "shopping": ''
    };
    facilitiesPart: Array<any>;
    allFacilities: Array<any>;
    facilityCollapsed: boolean;

    constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {
        this.facilityCollapsed = true;
        this.regionCollapsed = true;
        this.tourCategoryCollapsed = true;
        this.categoriesCollapsed = true;
        this.facilitiesPart = [];
        this.allFacilities = [];
        this.regionsPart = [];
        this.allRegions = [];
        this.allTourCategories = [];
        this.tourCategoriesPart = [];
        this.allCategories = [];
        this.categoriesPart = [];
    }

    ngOnInit() {
        this.route.url.subscribe(data => {
            this.next = null;

            if (data.length == 3) {
                this.type = data[1]['path'];
                this.route.params.subscribe(params => {
                    this.slug = params['slug'];
                    if (this.type == 'tours-and-activities') {
                        this.getTourMaxPrice();
                        this.checked_tour_categories.push(this.slug);
                        this.http.get(Conf.API_URL + '/category-for-tour/?slug=' + this.slug).subscribe(
                            data => {
                                this.category = data['results'][0];
                                this.selected_tour_categories = this.category.id;
                                this.getThingsToDo();
                            },
                            error => {
                                console.log(error.error)
                            }
                        );
                    } else {
                        this.getThingsMaxPrice();
                        this.checked_categories.push(this.slug);
                        this.http.get(Conf.API_URL + '/categories/?slug=' + this.slug).subscribe(
                            data => {
                                this.category = data['results'][0];
                                this.selected_categories = this.category.id;
                                this.getThingsToDo();
                            },
                            error => {
                                console.log(error.error)
                            }
                        );
                    }
                });
            } else if (data.length == 2) {
                this.type = data[1]['path'];
                if (this.type != 'tours-and-activities') {
                    this.getThingsMaxPrice();
                    this.http.get(Conf.API_URL + '/categories/?slug=' + this.type).subscribe(
                        data => {
                            this.category = data['results'][0];
                            this.getThingsToDo();
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                } else {
                    this.getTourMaxPrice();
                    this.getThingsToDo();
                }
            } else {
                this.getMaxPrice();
                this.getThingsToDo();
            }
        });

        this.getRegions();
        this.getCategories();
        this.getCategoriesParentsCount();
        this.getFacilityGroups();
    }


    getMaxPrice() {
        this.http.get(Conf.API_URL + '/things-to-do-max-price/').subscribe(
            data => {
                const max_price = data['results'];
                this.http.get(Conf.API_URL + '/tour-max-price/').subscribe(
                    data => {
                        if (data['results'] > max_price) {
                            this.max_price = data['results'];
                        } else {
                            this.max_price = max_price;
                        }
                    },
                    error => {
                        console.log(error.error)
                    }
                );
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getThingsMaxPrice() {
        this.http.get(Conf.API_URL + '/things-to-do-max-price/').subscribe(
            data => {
                this.max_price = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getTourMaxPrice() {
        this.http.get(Conf.API_URL + '/tour-max-price/').subscribe(
            data => {
                this.max_price = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getCategoriesParentsCount() {
        this.http.get(Conf.API_URL + '/things_to_do-parent-categories/').subscribe(
            data => {
                this.parent_categories = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    selectCategory(slug) {
        this.slug = slug;
        if (this.checked_categories.indexOf(slug) === -1) {
            this.checked_categories.push(slug);
        } else {
            this.checked_categories.splice($.inArray(slug, this.checked_categories), 1);
        }
        this.selected_categories = $('input[name="category"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getCategory()
    }

    choseTourCategory(slug) {
        this.slug = slug;
        if (this.checked_tour_categories.indexOf(slug) === -1) {
            this.checked_tour_categories.push(slug);
        } else {
            this.checked_tour_categories.splice($.inArray(slug, this.checked_tour_categories), 1);
        }
        this.selected_tour_categories = $('input[name="tour_category"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getCategory()
    }


    getCategory() {
        if (this.type == 'tours-and-activities') {
            this.http.get(Conf.API_URL + '/category-for-tour/?slug=' + this.slug).subscribe(
                data => {
                    this.category = data['results'][0];
                },
                error => {
                    console.log(error.error)
                }
            );
        } else {
            this.http.get(Conf.API_URL + '/categories/?slug=' + this.slug).subscribe(
                data => {
                    this.category = data['results'][0];
                },
                error => {
                    console.log(error.error)
                }
            );
        }
        this.getThingsToDo();
    }


    getRegions() {
        var url = Conf.API_URL + '/get-joined-areas/?category=things-to-do';
        if (this.type) {
            url = Conf.API_URL + '/get-joined-areas/?category=' + this.type;
        }

        this.http.get(url).subscribe(
            data => {
                this.allRegions = data['results'];
                if (this.allRegions.length > 10) {
                    this.allRegions['hasMore'] = true;
                }
                this.regionsPart = JSON.parse(JSON.stringify(this.allRegions)).slice(0, 10);
                this.regions = this.regionsPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getCategories() {
        if (this.type) {
            if (this.type == 'tours-and-activities') {
                this.getTourCategories();
            } else {
                this.http.get(Conf.API_URL + '/categories/?show_all&count=0&parent=' + this.type).subscribe(
                    data => {
                        this.allCategories = data['results'];
                        this.categoryHasMore = this.allCategories.length > 10;
                        this.categoriesPart = JSON.parse(JSON.stringify(this.allCategories)).slice(0, 10);
                        this.categories = this.categoriesPart;
                    },
                    error => {
                        console.log(error.error)
                    }
                );
            }
        }
    }

    getTourCategories() {
        this.http.get(Conf.API_URL + '/category-for-tour/?show_all&count=0').subscribe(
            data => {
                this.allTourCategories = data['results'];
                this.tourHasMore = this.allTourCategories.length > 10;
                this.tourCategoriesPart = JSON.parse(JSON.stringify(this.allTourCategories)).slice(0, 10);
                this.tour_categories = this.tourCategoriesPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getFacilityGroups() {
        this.http.get(Conf.API_URL + '/things-to-do-facility-groups/?show_all').subscribe(
            data => {
                this.allFacilities = data['results'];
                this.allFacilities.forEach(group => {
                    if (group.facilities.length > 10) {
                        group.hasMore = true;
                    }
                });

                this.facilitiesPart = JSON.parse(JSON.stringify(this.allFacilities));
                this.facilitiesPart.forEach(group => {
                    group.facilities = group.facilities.slice(0, 10);
                });

                this.facilityGroups = JSON.parse(JSON.stringify(this.facilitiesPart));
            },
            error => {
                console.log(error.error)
            }
        );
    }

    showMore(type: string) {
        switch (type) {
            case 'facility': {
                this.facilityGroups = this.facilityCollapsed ? this.allFacilities : this.facilitiesPart;
                this.facilityCollapsed = !this.facilityCollapsed;
                break;
            }
            case 'region': {
                this.regions = this.regionCollapsed ? this.allRegions : this.regionsPart;
                this.regionCollapsed = !this.regionCollapsed;
                break;
            }
            case 'tour': {
                this.tour_categories = this.tourCategoryCollapsed ? this.allTourCategories : this.tourCategoriesPart;
                this.tourCategoryCollapsed = !this.tourCategoryCollapsed;
                break;
            }
            case 'category': {
                this.categories = this.categoriesCollapsed ? this.allCategories : this.categoriesPart;
                this.categoriesCollapsed = !this.categoriesCollapsed;
                break;
            }
        }
    }

    choseRegion() {
        this.selected_regions = $('input[name="location"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getThingsToDo();
    }

    choseFacility() {
        this.selected_facilities = $('input[name="facility"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getThingsToDo();
    }

    choseRange(e) {
        this.fee_start = e.from;
        this.fee_end = e.to;
        this.getThingsToDo();
    }

    getThingsToDo() {
        if (this.type) {
            this.allThings = [];
            if (this.type == 'tours-and-activities') {
                this.getTours()
            } else {
                this.getThings()
            }
        } else {
            this.tours = [];
            this.thingsToDos = [];
            this.getAllThings();
        }

    }

    getAllThings() {
        var url = Conf.API_URL + '/all-things-to-do/?' +
            'facility=' + this.selected_facilities +
            '&location=' + this.selected_regions;

        if (this.fee_end !== 'end') {
            url += '&fee_start=' + this.fee_start + '&fee_end=' + this.fee_end;
        }

        this.http.get(url).subscribe(
            data => {
                this.allThings = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getThings() {
        var url = Conf.API_URL + '/things-to-do/' +
            '?parent_category=' + this.type +
            '&category=' + this.selected_categories +
            '&facility=' + this.selected_facilities +
            '&location=' + this.selected_regions;

        if (this.fee_end !== 'end') {
            url += '&fee_start=' + this.fee_start + '&fee_end=' + this.fee_end;
        }

        this.http.get(url).subscribe(
            data => {
                this.thingsToDos = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getTours() {
        var url = Conf.API_URL + '/tour/' +
            '?category=' + this.selected_tour_categories +
            '&location=' + this.selected_regions;

        if (this.fee_end !== 'end') {
            url += '&fee_start=' + this.fee_start + '&fee_end=' + this.fee_end;
        }

        this.http.get(url).subscribe(
            data => {
                this.tours = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    loadMore() {
        this.http.get(this.next).subscribe(
            data => {
                if (this.type) {
                    if (this.type == 'tours-and-activities') {
                        this.tours = this.tours.concat(data['results']);
                    } else {
                        this.thingsToDos = this.thingsToDos.concat(data['results']);
                    }
                } else {
                    this.allThings = this.allThings.concat(data['results']);
                }

                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html)
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/attractions-list/attractions-list.component.ts